export default __webpack_public_path__ + "static/fall27-d4f1f5d364662f4ea946173013990027.webp";